import { render } from "./DigitalSale.vue?vue&type=template&id=5b563d35"
import script from "./DigitalSale.vue?vue&type=script&lang=js"
export * from "./DigitalSale.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__